import React, { useEffect, useState } from "react";
import { ParagraphButtonData, NextConditionData, ParagraphInputQuickReply } from "@/model/paragraph";
import { filterNextConditionData, filterParagraphButtonData } from "@/util/helper/paragraphHelper";

import { ParagraphInputsProps } from "../model";
import { ButtonSortableList, NextConditionSortableList } from "../input";


const ParagraphInputQuickReplyCardInputs: React.FC<ParagraphInputsProps<ParagraphInputQuickReply>> = (props) => {
    const { paragraph, onChange } = props;

    const [buttons, setButtons] = useState<ParagraphButtonData[]>();
    const [conditions, setConditions] = useState<NextConditionData[]>();

    const onChangeButtons = (buttons: ParagraphButtonData[]) => {
        setButtons(buttons);
        onChange({
            ...paragraph,
            data: [...buttons, ...conditions ?? []]
        });
    };

    const onChangeConditions = (conditions: NextConditionData[]) => {
        setConditions(conditions);
        onChange({
            ...paragraph,
            data: [...buttons ?? [], ...conditions]
        });
    };

    useEffect(() => {
        setButtons(filterParagraphButtonData(paragraph.data ?? []));
        setConditions(filterNextConditionData(paragraph.data ?? []));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!buttons || !conditions) {
        return null;
    }

    return (<>
        <ButtonSortableList required
                            className="col-span-2 flex flex-col gap-1.5"
                            defaultButtons={buttons}
                            onChange={onChangeButtons}
        />
        <NextConditionSortableList className="col-span-2 flex flex-col gap-1.5"
                                   required={false}
                                   defaultConditions={conditions}
                                   onChangeConditions={onChangeConditions}
        />
    </>);
};

export default ParagraphInputQuickReplyCardInputs;
